
import { RangerEntityDecorator } from './ranger.decorator';
import { Ranger } from './ranger.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class RangerTypeInfoBase implements CrudTypeInfo<Ranger, number> {
  name = 'Ranger';
  entityDecorator = new RangerEntityDecorator();
  
  createAuthorities = ['WRITE_RANGER'];
  editAuthorities = ['WRITE_RANGER'];
  deleteAuthorities = ['WRITE_RANGER'];
  viewAuthorities = ['READ_RANGER'];
  
  searchRouteBase = ['/ranger/search'];
  createRouteBase = ['/ranger/create'];
  editRouteBase = ['/ranger/edit'];
  viewRouteBase = ['/ranger/view'];
  
  description(item: Ranger): string {
    return '' +  item.rangerId +  ' - ' +  item.name;
  }
}



